import { useInfiniteQuery } from "@tanstack/react-query";
import { http } from "../../../../../../services/HttpService";
import { HTTP_ENDPOINTS } from "../../../../../../consts/api";
import { getNextPaginationPage } from "../../../../../../schemas/pagination";

export const usePatientWalletSummary = (params, options = {}) => {
  return useInfiniteQuery({
    queryKey: ["patientWalletSummary", params],
    queryFn: async ({ pageParam = 1 }) => {
      try {
        const res = await http.get(HTTP_ENDPOINTS.getPatientWalletSummary(), {
          params: {
            ...params,
            limit: 20,
            page: pageParam,
          },
        });

        if (res.data.status !== 200) {
          throw new Error(
            res.data.message || "Failed to fetch patient wallet summary",
          );
        }

        const reportData = res.data.data.report_data || [];
        const apiPagination = res.data.data.pagination || {};

        // Determine hasNextPage by comparing current_page with last_page from apiPagination
        const hasNextPage =
          apiPagination.current_page < apiPagination.last_page;

        const paginationInfo = {
          currentPage: apiPagination.current_page || pageParam,
          total: apiPagination.total || 0,
          totalPages: apiPagination.last_page || 0,
          hasNextPage: hasNextPage,
          nextPage: hasNextPage ? pageParam + 1 : undefined,
        };

        const composeResponse = {
          ...paginationInfo,
          reportData: reportData,
          summary: res.data.data.summary || {},
          reportHeader: res.data.data.report_header || {},
          clinics: res.data.data.clinics || [],
          globalSettings: res.data.global_settings || {},
          exportFile: res.data.data.file || null, // For export responses
        };

        return composeResponse;
      } catch (error) {
        throw error;
      }
    },
    ...options,
    getNextPageParam: getNextPaginationPage,
    retry: false, // Don't retry failed requests for now
  });
};
